import { render, staticRenderFns } from "./adminRoleLists.vue?vue&type=template&id=019b65f8&scoped=true&"
import script from "./adminRoleLists.vue?vue&type=script&lang=js&"
export * from "./adminRoleLists.vue?vue&type=script&lang=js&"
import style0 from "./adminRoleLists.vue?vue&type=style&index=0&id=019b65f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019b65f8",
  null
  
)

export default component.exports